import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setFormSettings, setImportData, setIsImportDataGridViewLoaded, setLoadingState, setPayersList } from "./ExcelImportSlice";
import IntegrationDataService from "../../../../../../services/IntegrationDataService";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../../components/toast/constants";
import { setFormAndTaxYearList } from "./ExcelImportSlice";
import PayerDataService from "../../../../../../services/PayerDataService";
import General from "../../../../../../libs/utility/General";
import FormsDataService from "../../../../../../services/FormsDataService";
import { QBD_LOADING_STATES } from "../../constants";

export const { getFormAndTaxYearList, getPayersList, getLoadImportData, getFormSetting } = {
    getFormAndTaxYearList: (payload) => {
        return {
            type: "QBD_EXCELIMPORT/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    getPayersList: (payload) => {
        return {
            type: "QBD_EXCELIMPORT/GET_PAYERS",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "QBD_EXCELIMPORT/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "QBD_EXCELIMPORT/GET_FORM_SETTING",
            payload: payload
        }
    },
}

function* getFormAndTaxYearListAsync() {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.DROPDOWNS_LOADING }));
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setFormAndTaxYearList(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Error Fetching Tax Year and Form Types", message: "An error occurred while fetching the tax year and form types. Please try again later or contact our support team for assistance." }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.DROPDOWNS_DATA_READY }));
    }
}
function* getPayersListAsync(action) {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.DROPDOWNS_LOADING }));
        const response = yield PayerDataService.getPayersList();

        const { Data, Message, Status } = response?.data;

        if (Status) {
            if (Data.length > 0) {
                General.addOptionAndValueKeys(Data, "LastName", "PayerDetailId")
                yield put(setPayersList(Data));
            }
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance." }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.DROPDOWNS_DATA_READY }));
    }
}
function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setImportData(response?.data?.Data));
            yield put(setIsImportDataGridViewLoaded(true));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: "Failed To Load Grid Import Data " }));
    }
    finally {
        yield put(setLoadingState({ state: QBD_LOADING_STATES.PAGE_DATA_READY }));
    }
}
function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setFormSettings(response?.data?.Data));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance." }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(getPayersList().type, getPayersListAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);